import Localization from "../localization";
import request from "./request";

const checkout = async ({
  service = "",
  name = "",
  type = "",
  successUrl = "",
  cancelUrl = "",
} = {}) => {
  const lang = Localization.getLanguage();
  const { data } = await request({
    method: "post",
    params: { lang },
    url: `rest/users/:userUuid/subscriptions/checkout`,
    data: {
      service,
      cancelUrl,
      successUrl,
      device: { type },
      paymentPlan: { name },
    },
  });
  return data;
};

const subscriptions = async () => {
  const lang = Localization.getLanguage();
  const { data } = await request({
    params: { lang },
    url: `rest/v6/users/:userUuid/subscriptions`,
  });
  return data;
};

const subscription = async (uuid) => {
  const lang = Localization.getLanguage();
  const { data } = await request({
    params: { lang },
    url: `rest/v6/users/:userUuid/subscriptions/${uuid}`,
  });
  return data;
};

const paymentPlans = async (uuid, { ...params } = {}) => {
  const lang = Localization.getLanguage();
  const { data } = await request({
    url: `/rest/v6/users/:userUuid/subscriptions/${uuid}/paymentplans`,
    params: { lang, ...params },
  });
  return data;
};

const planProration = async (uuid, { plan } = {}) => {
  const { data } = await request({
    url: `/rest/v6/users/:userUuid/subscriptions/${uuid}/proration/${plan}`,
  });
  data.amount = Math.round(data.amount * 100) / 100;
  return data;
};

const upgradePlan = async (uuid, { plan } = {}) => {
  const { data } = await request({
    method: "post",
    url: `/rest/v6/users/:userUuid/subscriptions/${uuid}/upgrade/${plan}`,
  });
  return data;
};

export default {
  checkout,
  upgradePlan,
  subscription,
  paymentPlans,
  subscriptions,
  planProration,
};
